import React, { useEffect, useState } from 'react'; 
import './PapperStyle.css';
import { useTranslation } from 'react-i18next';
import axios from 'axios';
import Supprimer from './Supprimer';
import { FRONT_URL, BACKEND_URL_PORTAIL, BACKEND_URL_DOC, BACKEND_URL_LOG } from '../../../config/const';
import { Card, Container } from "reactstrap";
import Breadcrumbs from "../../../components/Common/Breadcrumb";



import Select from "react-select";
function QuessCleanroomList() {

  const idGroup = localStorage.getItem('currentOrg');
  const { t } = useTranslation();
  const [cleanroomByUser, setCleanroomByUser] = useState([]);
  const [hidden, setHidden] = useState(true);
  const [currentItemId, setCurrentItemId] = useState(0);
  const [cleanroomName, setCleanroomName] = useState('');
  const [cleanroomNameUpdated, setCleanroomNameUpdated] = useState('');
  const [groupUsers, setGroupUsers] = useState([]);
  const [selectedUser, setSelectedUser] = useState('');
  const [errorMessageCleanroom, setErrorMessageCleanroom] = useState('');

   document.title=  t('QuessCleanroomManagement') +" | " +t('quessCompounding')

const [isAddDisabled, setIsAddDisabled] = useState(false);
  const customStyles = {
    option: (provided, state) => ({
      ...provided,
      color: 'black', // texte en noir
    }),
    singleValue: (provided) => ({
      ...provided,
      color: 'black', // valeur sélectionnée en noir
    }),
    placeholder: (provided) => ({
      ...provided,
      color: 'black', // placeholder aussi en noir si tu veux
    }),
  };

  
  useEffect(() => {
    getAllCleanroomsByGroup(idGroup);
    getAllGroupUsers(idGroup)
  }, []);

  const getAllCleanroomsByGroup = (idGroup) => {
    axios.get(`${BACKEND_URL_LOG}getClientCleanRooms/${idGroup}`, {
      headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
    }).then(response =>{
      
      setCleanroomByUser(response.cleanRooms);}).catch(error => console.error(error)).catch(error => console.error(error));
  };
  const updateCleanroomGroup = (idCleanroom ,idResponsable) => { 
    const data = { name: cleanroomNameUpdated, id: idCleanroom, idOrganisation: idGroup ,idResponsable: idResponsable};

    Promise.all([
        axios.post(`${BACKEND_URL_LOG}saveCleanRoom`, data, {
            headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
        }),
       /*  axios.post(`${BACKEND_URL_DOC}saveCleanRoom`, data, {
            headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
        }) */
    ]).then(() => {
        setTimeout(() => {
            //getAllCleanroomsByGroup(idGroup);
            setHidden(true);
            setCleanroomNameUpdated('');
            window.location.reload();
        }, 1500);
    }).catch(error => console.error("Error updating cleanroom:", error));
};

const addCleanroomGroup = () => {
    if (!cleanroomName.trim() || !selectedUser) {
        setErrorMessageCleanroom(t('errorMessageCleanroom'));
        return;
    }

    setErrorMessageCleanroom('');
    const data = { name: cleanroomName, id:"", idOrganisation: idGroup,idResponsable: selectedUser.value };

    Promise.all([
        axios.post(`${BACKEND_URL_LOG}saveCleanRoom`, data, {
            headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
        }),
        /* axios.post(`${BACKEND_URL_DOC}saveCleanRoom`, data, {
            headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
        }) */
    ]).then(() => {
        setTimeout(() => {
            //getAllCleanroomsByGroup(idGroup);
            setCleanroomName('');
            setSelectedUser('');
            window.location.reload();
        }, 1500);
    }).catch(error => console.error("Error adding cleanroom:", error));
};

  const getAllGroupUsers = (idGroup) => {
    const config = {
      headers: {
        Authorization: 'Bearer ' + localStorage.getItem('token')
      }
    };
    const data={
      groupId:idGroup
    }
    axios.post(BACKEND_URL_PORTAIL + 'api/getGroupUsersCleanroom', data,config)
      .then(response => {
        const usersOptions = response.map((el) => ({
          label: el.name,
          value: el.idUser,
        }));
      
        setGroupUsers(usersOptions);
        }
      ).catch(error => console.error(error));
  };
  function handleSelectResp (selectedOption){
    setSelectedUser(selectedOption);
  }
  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
           <Card className="card-bordred custom-card">
<Breadcrumbs title={t('QuessCleanroomManagement')} breadcrumbItem={t('listOfCleanrooms')} />
          <div className="d-flex justify-content-center mb-3">
            <input 
              className="form-control w-25 me-2 inputCleanroom" 
              placeholder={t('cleanroomName')} 
              value={cleanroomName} 
              onChange={(e) => setCleanroomName(e.target.value)} 
            />
           
            <Select  value={selectedUser}  onChange={handleSelectResp}  options={groupUsers} 
                  classNamePrefix="select2-selection"  placeholder={t("SelectUser")}   styles={customStyles} isDisabled={isAddDisabled} />
            <button className="btn btn-primary btnAddCleanroom" onClick={addCleanroomGroup}>{t('addCleanroomName')}</button>
          </div>
          {errorMessageCleanroom && <p className="text-danger text-center">{errorMessageCleanroom}</p>}
          <ul className="list-group">
            {/* En-têtes */}
            <li className="list-group-item d-flex justify-content-between">
              <div style={{ flex: 2 }}  className="d-flex">{t('cleanroom')}</div>
              <div style={{ flex: 1 }}   className="d-flex">{t('responsible')}</div>
                <div style={{ flex: 2 }}  className="d-flex"></div>
            </li>

            {cleanroomByUser && cleanroomByUser.length > 0 ? (
                cleanroomByUser.map((item) => (
                  <li key={item.id} className="list-group-item d-flex align-items-center">
            

            
              {hidden === false && item.id === currentItemId ? (
                <>
                  <div style={{ flex: 2 }} className="d-flex">
                
                      <input
                        className="form-control me-2 inputCleanroomUpdate"
                        value={cleanroomNameUpdated}
                        onChange={(e) => setCleanroomNameUpdated(e.target.value)}
                      />
                      </div>
                       <div style={{ flex: 1}}>
                      <Select
                        value={groupUsers.find(option => option.value === selectedUser)}
                        onChange={(selectedOption) => setSelectedUser(selectedOption.value)}
                        options={groupUsers}
                        classNamePrefix="select2-selection"
                        placeholder={t("SelectUser")}
                        styles={{ ...customStyles, container: base => ({ ...base, width: 200, marginRight: '10px' }) }}
                      />
                  </div>
                  <div style={{ flex:2 }} className="d-flex">
                      <button className="btn btn-primary me-2 ContactBtn" onClick={() => updateCleanroomGroup(item.id, selectedUser)}>
                        {t('SAVE')}
                      </button>
                      <button className="btn btn-primary ContactBtn" onClick={() => {
                        setHidden(true);
                        setCleanroomNameUpdated('');
                        setSelectedUser('');
                        setIsAddDisabled(false);
                      }}>
                        {t('cancel')}
                      </button>
                
                  </div>
                </>
              ) : (
            <>
                <div style={{ flex: 2 }}>
              <span className="fw-bold">{item.name}</span>
            </div>
            
            <div style={{ flex: 1}}>
              <span className="fw-bold">{item.responsable?.name || t('NoResponsable')}</span>
            </div>
                <div style={{ flex: 2 }} className="d-flex">
              
                  <button
                    className="btn btn-primary me-2 ContactBtn"
                    onClick={() => {
                      setHidden(false);
                      setCurrentItemId(item.id);
                      setCleanroomNameUpdated(item.name);
                      setSelectedUser(item.responsable?.idUser || '');
                      setIsAddDisabled(true); 
                    }}
                  >
                    
                    {t('UPDATE')}
                  </button>
                

                  
                  <Supprimer ItemId={item.id} name={item.name} idOrganisation={idGroup} />
                
                </div>
            </>
    )}
  
</li>

                ))
              ) : (
                <p className="text-center text-muted">{t('noCleanrooms')}</p>
              )}

          </ul>


           </Card>
          
        </Container>
      </div>
    </React.Fragment>
  );
}

export default QuessCleanroomList;